/// <reference path="../app.js"/>

function contactForm_recaptchaCallback(token) {
	$("#contact-form").find(".recaptcha-token").val(token);
	$("#contact-form").submit();
}

class ContactForm {
	static doFocus() {
		const field = $("#contact-form input").first();
		const { top } = field[0].getBoundingClientRect();

		if (field.val() == "" && top < innerHeight && innerWidth > innerHeight) field.focus();
	}

	static init() {
		if ($("#contact-form").length == 0) return;

		$("#contact-form").on("submit force-submit", function (event) {
			const form = $(this);
			const formData = form.serialize();

			form.addClass("submitted");

			setTimeout(() => form.addClass("no-gif"), 1500);

			$.post("/home/submitContactForm", formData, result => {
				form.find(".message").text(JSON.parse(result).message);
			});

			event.preventDefault();
			return false;
		});

		$(document).on("scroll", this.doFocus);

		$(document).ready(this.doFocus)
	}
}